import {
  ALL_VEHICLES_LISTING_SECTION_ID,
  AUTOCARAVANS_AND_TRAILERS_VEHICLES_LISTING_SECTION_ID,
  CLASSIC_AND_COMPETITION_VEHICLES_LISTING_SECTION_ID,
  KM0_VEHICLES_LISTING_SECTION_ID,
  NEW_VEHICLES_LISTING_SECTION_ID,
  NO_LICENSE_VEHICLES_LISTING_SECTION_ID,
  RENTING_VEHICLES_LISTING_SECTION_ID,
  SECOND_HAND_VEHICLES_LISTING_SECTION_ID,
  VANS_AND_COMMERCIAL_VEHICLES_LISTING_SECTION_ID
} from '../common/listingSections.js'
import {
  AUTOCARAVANS_AND_TRAILERS_CATEGORY1_ID,
  CARS_CATEGORY1_ID,
  CARS_WITHOUT_LICENSE_CATEGORY1_ID,
  CLASSIC_AND_COMPETITION_CARS_CATEGORY1_ID,
  VANS_AND_COMMERCIAL_CATEGORY1_ID
} from './vehicleSpecifications/categories.js'
import {
  OFFER_TYPE_DEMONSTRATION,
  OFFER_TYPE_KM0,
  OFFER_TYPE_MANAGEMENT,
  OFFER_TYPE_NEW,
  OFFER_TYPE_PRE_OWNED,
  OFFER_TYPE_RENTAL,
  OFFER_TYPE_SECOND_HAND,
  OFFER_TYPE_SUBSCRIPTION,
  OFFER_TYPE_SUBSTITUTION
} from './search.js'

export const LISTING_SECTION_IDS_BY_CATEGORIES = {
  [CARS_CATEGORY1_ID]: ALL_VEHICLES_LISTING_SECTION_ID,
  [CARS_WITHOUT_LICENSE_CATEGORY1_ID]: NO_LICENSE_VEHICLES_LISTING_SECTION_ID,
  [CLASSIC_AND_COMPETITION_CARS_CATEGORY1_ID]: CLASSIC_AND_COMPETITION_VEHICLES_LISTING_SECTION_ID,
  [VANS_AND_COMMERCIAL_CATEGORY1_ID]: VANS_AND_COMMERCIAL_VEHICLES_LISTING_SECTION_ID,
  [AUTOCARAVANS_AND_TRAILERS_CATEGORY1_ID]: AUTOCARAVANS_AND_TRAILERS_VEHICLES_LISTING_SECTION_ID
}

export const LISTING_SECTION_IDS_BY_CATEGORIES_AND_OFFER_TYPES = {
  [CARS_CATEGORY1_ID]: {
    [OFFER_TYPE_SECOND_HAND]: SECOND_HAND_VEHICLES_LISTING_SECTION_ID,
    [OFFER_TYPE_NEW]: NEW_VEHICLES_LISTING_SECTION_ID,
    [OFFER_TYPE_KM0]: KM0_VEHICLES_LISTING_SECTION_ID,
    [OFFER_TYPE_SUBSTITUTION]: ALL_VEHICLES_LISTING_SECTION_ID,
    [OFFER_TYPE_MANAGEMENT]: ALL_VEHICLES_LISTING_SECTION_ID,
    [OFFER_TYPE_DEMONSTRATION]: ALL_VEHICLES_LISTING_SECTION_ID,
    [OFFER_TYPE_RENTAL]: ALL_VEHICLES_LISTING_SECTION_ID,
    [OFFER_TYPE_PRE_OWNED]: ALL_VEHICLES_LISTING_SECTION_ID,
    [OFFER_TYPE_SUBSCRIPTION]: RENTING_VEHICLES_LISTING_SECTION_ID
  },
  [CARS_WITHOUT_LICENSE_CATEGORY1_ID]: {
    [OFFER_TYPE_SECOND_HAND]: NO_LICENSE_VEHICLES_LISTING_SECTION_ID,
    [OFFER_TYPE_NEW]: NO_LICENSE_VEHICLES_LISTING_SECTION_ID,
    [OFFER_TYPE_KM0]: NO_LICENSE_VEHICLES_LISTING_SECTION_ID,
    [OFFER_TYPE_SUBSTITUTION]: NO_LICENSE_VEHICLES_LISTING_SECTION_ID,
    [OFFER_TYPE_MANAGEMENT]: NO_LICENSE_VEHICLES_LISTING_SECTION_ID,
    [OFFER_TYPE_DEMONSTRATION]: NO_LICENSE_VEHICLES_LISTING_SECTION_ID,
    [OFFER_TYPE_RENTAL]: NO_LICENSE_VEHICLES_LISTING_SECTION_ID,
    [OFFER_TYPE_PRE_OWNED]: NO_LICENSE_VEHICLES_LISTING_SECTION_ID,
    [OFFER_TYPE_SUBSCRIPTION]: RENTING_VEHICLES_LISTING_SECTION_ID
  },
  [CLASSIC_AND_COMPETITION_CARS_CATEGORY1_ID]: {
    [OFFER_TYPE_SECOND_HAND]: CLASSIC_AND_COMPETITION_VEHICLES_LISTING_SECTION_ID,
    [OFFER_TYPE_NEW]: CLASSIC_AND_COMPETITION_VEHICLES_LISTING_SECTION_ID,
    [OFFER_TYPE_KM0]: CLASSIC_AND_COMPETITION_VEHICLES_LISTING_SECTION_ID,
    [OFFER_TYPE_SUBSTITUTION]: CLASSIC_AND_COMPETITION_VEHICLES_LISTING_SECTION_ID,
    [OFFER_TYPE_MANAGEMENT]: CLASSIC_AND_COMPETITION_VEHICLES_LISTING_SECTION_ID,
    [OFFER_TYPE_DEMONSTRATION]: CLASSIC_AND_COMPETITION_VEHICLES_LISTING_SECTION_ID,
    [OFFER_TYPE_RENTAL]: CLASSIC_AND_COMPETITION_VEHICLES_LISTING_SECTION_ID,
    [OFFER_TYPE_PRE_OWNED]: CLASSIC_AND_COMPETITION_VEHICLES_LISTING_SECTION_ID,
    [OFFER_TYPE_SUBSCRIPTION]: RENTING_VEHICLES_LISTING_SECTION_ID
  },
  [VANS_AND_COMMERCIAL_CATEGORY1_ID]: {
    [OFFER_TYPE_SECOND_HAND]: VANS_AND_COMMERCIAL_VEHICLES_LISTING_SECTION_ID,
    [OFFER_TYPE_NEW]: VANS_AND_COMMERCIAL_VEHICLES_LISTING_SECTION_ID,
    [OFFER_TYPE_KM0]: VANS_AND_COMMERCIAL_VEHICLES_LISTING_SECTION_ID,
    [OFFER_TYPE_SUBSTITUTION]: VANS_AND_COMMERCIAL_VEHICLES_LISTING_SECTION_ID,
    [OFFER_TYPE_MANAGEMENT]: VANS_AND_COMMERCIAL_VEHICLES_LISTING_SECTION_ID,
    [OFFER_TYPE_DEMONSTRATION]: VANS_AND_COMMERCIAL_VEHICLES_LISTING_SECTION_ID,
    [OFFER_TYPE_RENTAL]: VANS_AND_COMMERCIAL_VEHICLES_LISTING_SECTION_ID,
    [OFFER_TYPE_PRE_OWNED]: VANS_AND_COMMERCIAL_VEHICLES_LISTING_SECTION_ID,
    [OFFER_TYPE_SUBSCRIPTION]: RENTING_VEHICLES_LISTING_SECTION_ID
  },
  [AUTOCARAVANS_AND_TRAILERS_CATEGORY1_ID]: {
    [OFFER_TYPE_SECOND_HAND]: AUTOCARAVANS_AND_TRAILERS_VEHICLES_LISTING_SECTION_ID,
    [OFFER_TYPE_NEW]: AUTOCARAVANS_AND_TRAILERS_VEHICLES_LISTING_SECTION_ID,
    [OFFER_TYPE_KM0]: AUTOCARAVANS_AND_TRAILERS_VEHICLES_LISTING_SECTION_ID,
    [OFFER_TYPE_SUBSTITUTION]: AUTOCARAVANS_AND_TRAILERS_VEHICLES_LISTING_SECTION_ID,
    [OFFER_TYPE_MANAGEMENT]: AUTOCARAVANS_AND_TRAILERS_VEHICLES_LISTING_SECTION_ID,
    [OFFER_TYPE_DEMONSTRATION]: AUTOCARAVANS_AND_TRAILERS_VEHICLES_LISTING_SECTION_ID,
    [OFFER_TYPE_RENTAL]: AUTOCARAVANS_AND_TRAILERS_VEHICLES_LISTING_SECTION_ID,
    [OFFER_TYPE_PRE_OWNED]: AUTOCARAVANS_AND_TRAILERS_VEHICLES_LISTING_SECTION_ID,
    [OFFER_TYPE_SUBSCRIPTION]: RENTING_VEHICLES_LISTING_SECTION_ID
  }
}
